// src/apiConfig.js
const BASE_URL = process.env.VUE_APP_BASE_URL;
const CORE_URL = process.env.VUE_APP_CORE_URL;
const API_URL = process.env.VUE_APP_API_URL;

export default {
  BASE_URL: BASE_URL,
  LOGIN: `${BASE_URL}/token`,

  // TENANTS
  GET_TENANTS: `${BASE_URL}/tenants`,
  CREATE_TENANT: `${BASE_URL}/tenants`,
  UPDATE_TENANT: (tenantId) => `${BASE_URL}/tenants/${tenantId}`,
  GET_TENANT_BY_ID: (tenantId) => `${BASE_URL}/tenants/${tenantId}`,
  GET_TENANT_USERS: (tenantId) => `${BASE_URL}/tenants/${tenantId}/users`,
  GET_TENANT_BY_TENANT_USER: (tenantId, userId) => `${BASE_URL}/tenants/${tenantId}/users/${userId}`,
  UPDATE_TENANT_USER_CLAIMS: (tenantId, userId) => `${BASE_URL}/tenants/${tenantId}/users/${userId}`,
  ADD_TENANT_USER: (tenantId) => `${BASE_URL}/tenants/${tenantId}/users`,
  DELETE_TENANT_USER: (tenantId, userId) => `${BASE_URL}/tenants/${tenantId}/users/${userId}`,
  RESET_TENANT_USER_PASSWORD: (tenantId, userId) => `${BASE_URL}/tenants/${tenantId}/users/${userId}/reset-password`,

  // EMPLOYEES
  GET_ALL_EMPLOYEES: (archiveStatus) => `${BASE_URL}${API_URL}/employees?archive_status=${archiveStatus}`,
  GET_SHORT_EMPLOYEES: (archiveStatus) => `${BASE_URL}${API_URL}/employees/short?archive_status=${archiveStatus}`,
  CREATE_EMPLOYEE: `${BASE_URL}${API_URL}/employees`,
  UPDATE_EMPLOYEE: (employeeId) => `${BASE_URL}${API_URL}/employees/update/${employeeId}`,
  GET_ALL_COMPANIES: `${BASE_URL}${API_URL}/companies/all`,
  CREATE_COMPANY: `${BASE_URL}${API_URL}/companies`,
  UPDATE_COMPANY: (companyId) => `${BASE_URL}${API_URL}/companies/update/${companyId}`,
  DELETE_COMPANY: (companyId) => `${BASE_URL}${API_URL}/companies/delete/${companyId}`,
  
  // ATTENDANCE
  INSERT_ATTENDANCE: `${BASE_URL}${API_URL}/insert-attendance`,
  GET_ATTENDANCE: `${BASE_URL}${API_URL}/get-attendance`,
  GET_ATTENDANCE_DATA: (batchName, employeeId, shiftType = 'SHIFT') => `${BASE_URL}${API_URL}/attendance/data/${batchName}/${employeeId}?shift_type=${shiftType}`,
  GET_ATTENDANCE_STATS: (batchName) => `${BASE_URL}${API_URL}/attendance/stats/${batchName}`,
  GET_ATTENDANCE_HPAY: (startTimestamp, endTimestamp) => `${BASE_URL}${API_URL}/attendance/hpay/${startTimestamp}/${endTimestamp}`,
  SEND_ATTENDANCE_REPORT: `${BASE_URL}${API_URL}/attendance/send-report-email`,

  // BATCH
  INSERT_BATCH: `${BASE_URL}${API_URL}/insert-batch`,
  GET_BATCH_COUNT: `${BASE_URL}${API_URL}/get-batch-count`,
  GET_PAYROLL_BATCHES: `${BASE_URL}${API_URL}/get-payroll-batches`,
  GET_BATCH_DATA: `${BASE_URL}${API_URL}/get-batch-data`,
  DELETE_BATCH: `${BASE_URL}${API_URL}/delete-batch`,
  CLEANUP_BATCH_STAGING: `${BASE_URL}${API_URL}/cleanup-batch-staging`,
  SYNC_EMPLOYEE_STRUCTURE: `${BASE_URL}${API_URL}/sync-employee-structure`,

  // STORY
  INSERT_STORY: `${BASE_URL}${API_URL}/insert-story`,
  GENERATE_COVERS: `${BASE_URL}${API_URL}/generate-covers`,
  GET_STORY: `${BASE_URL}${API_URL}/get-story`,
  UPDATE_BATCH_STATUS: `${BASE_URL}${API_URL}/update-batch-status`,
  UPDATE_STORY_TOTALS: `${BASE_URL}${API_URL}/update-total-stories`,
  SCORE_ADJUSTMENT: `${BASE_URL}${API_URL}/score-adjustments`,
  GET_EOTM_CANDIDATES: `${BASE_URL}${API_URL}/eotm-candidates`,
  REPLACE_EMPLOYEE_AUTOMATED_STORIES: `${BASE_URL}${API_URL}/replace-employee-automated-stories`,


  DELETE_STORY_BY_BATCH: `${BASE_URL}${API_URL}/delete-story-by-batch`,
  DELETE_STORY: `${BASE_URL}${API_URL}/delete-story`,
  DELETE_EMPLOYEE_ESP: `${BASE_URL}${API_URL}/delete-employee-esp`,
  DELETE_ATTENDANCE_BY_BATCH: `${BASE_URL}${API_URL}/delete-attendance-by-batch`,

  // ANNUALS
  GET_ANNUALS_COUNT: `${BASE_URL}${API_URL}/get-annuals-batch-count`,
  GET_ANNUALS_BY_BATCH: `${BASE_URL}${API_URL}/get-annuals-by-batch`,
  GET_ANNUALS_BY_EMPLOYEE: `${BASE_URL}${API_URL}/get-annuals-by-employee`,
  GET_ANNUALS_BY_STATUS: `${BASE_URL}${API_URL}/get-annuals-by-status`,
  UPDATE_ANNUALS_BY_STATUS: `${BASE_URL}${API_URL}/update-annuals-by-status`,
  GET_ESP_ANNUALS_SUMMARY: `${BASE_URL}${API_URL}/annuals/esp-summary`,
  UPDATE_ESP_ANNUALS: `${BASE_URL}${API_URL}/annuals/esp-action`,
  GET_EMPLOYEE_ESP_ANNUALS: (employeeId) => `${BASE_URL}${API_URL}/annuals/esps/${employeeId}`,
  UPDATE_EMPLOYEE_ESP_ANNUALS: (employeeId) => `${BASE_URL}${API_URL}/annuals/esps/${employeeId}/status`,

  // STRUCTURE
  GET_STRUCTURE: `${BASE_URL}${API_URL}/get-structure`,
  CREATE_STRUCTURE: `${BASE_URL}${API_URL}/create-structure`,
  DELETE_STRUCTURE: `${BASE_URL}${API_URL}/delete-structure`,
  UPDATE_STRUCTURE: `${BASE_URL}${API_URL}/update-structure`,

  // PAYROLL
  GET_PAYROLL_COUNT: `${BASE_URL}${API_URL}/get-payroll-count`,
  GET_PAYROLL_BY_BATCH: `${BASE_URL}${API_URL}/get-payroll-by-batch`,
  GET_PAYROLL_BY_EMPLOYEE: `${BASE_URL}${API_URL}/get-payroll-by-employee`,
  CLOSE_PAYROLL: `${BASE_URL}${API_URL}/close-payroll`,

  // PAYSLIP
  PAYSLIP_STATUS: `${BASE_URL}${API_URL}/payslips/status`,
  UPLOAD_PAYSLIP: `${BASE_URL}${API_URL}/payslips/upload`,
  PREVIEW_STORED_PAYSLIP: `${BASE_URL}${API_URL}/payslips/preview`,
  GET_PAYSLIP_URL: `${BASE_URL}${API_URL}/get-payslip-url`,
  SEND_PAYSLIP_BY_EMAIL: `${BASE_URL}${API_URL}/send-payslip-by-email`,
  SEND_ANNUALS_BY_EMAIL: `${BASE_URL}${API_URL}/send-annuals-by-email`,

  /// External
  GET_EMPLOYEES_EXTERNAL: `${CORE_URL}/external/get-employees/employees-data`,
  GET_HPAY_DATA_EXTERNAL: `${CORE_URL}/external/get-attendance/hpay`,
  GET_ATTENDANCE_DATA_EXTERNAL: `${CORE_URL}/external/get-attendance/data`,
  GET_EMPLOYEES_STATS_EXTERNAL: `${CORE_URL}/external/get-attendance/stats`,
  GET_LEAVES_EXTERNAL: `${CORE_URL}/external/get-leaves/data`,

  // INVOICES
  GET_INVOICE_BATCHES: `${BASE_URL}${API_URL}/invoice/get-batches`,
  GET_INVOICES: `${BASE_URL}${API_URL}/invoice/generate`,
  GET_INVOICES_ALL: `${BASE_URL}${API_URL}/invoice/all`,
  GET_INVOICES_VIEW: `${BASE_URL}${API_URL}/invoice/view`,
  GET_INVOICES_PAID: `${BASE_URL}${API_URL}/invoice/paid`,
  GET_INVOICES_UNPAID: `${BASE_URL}${API_URL}/invoice/unpaid`,
  GET_INVOICES_DELETE: `${BASE_URL}${API_URL}/invoice/delete`,
  UPDATE_INVOICE: `${BASE_URL}${API_URL}/invoice`,
  DELETE_INVOICE_BATCH: `${BASE_URL}${API_URL}/invoice/delete-batch`,
  CREATE_INVOICE: `${BASE_URL}${API_URL}/invoice/create`,
  GET_INVOICE_PDF: `${BASE_URL}${API_URL}/invoice/get-invoice-pdf`,
  PAYMENT_PROFILES: `${BASE_URL}${API_URL}/invoice/payment-profiles`,
  PAYMENT_PROFILE: (profileId) => `${BASE_URL}${API_URL}/invoice/payment-profiles/${profileId}`,
  INVOICE_PAYMENTS: (invoiceId) => `${BASE_URL}${API_URL}/invoice/${invoiceId}/payments`,
  VOID_INVOICE_PAYMENT: (invoiceId, paymentId) => `${BASE_URL}${API_URL}/invoice/${invoiceId}/payments/${paymentId}/void`,

  // EXPENSES
  STATEMENT_IMPORTS: `${BASE_URL}${API_URL}/expenses/statement-imports`,
  EXPENSE_PERIODS: `${BASE_URL}${API_URL}/expenses/periods`,
  EXPENSE_PERIOD: (periodId) => `${BASE_URL}${API_URL}/expenses/periods/${periodId}`,
  EXPENSE_PERIOD_SUMMARY: (periodId) => `${BASE_URL}${API_URL}/expenses/periods/${periodId}/summary`,
  EXPENSE_ACCOUNTS: `${BASE_URL}${API_URL}/expenses/accounts`,
  EXPENSE_ACCOUNT: (accountId) => `${BASE_URL}${API_URL}/expenses/accounts/${accountId}`,
  EXPENSE_CATEGORIES: `${BASE_URL}${API_URL}/expenses/categories`,
  EXPENSE_CATEGORY: (categoryId) => `${BASE_URL}${API_URL}/expenses/categories/${categoryId}`,
  EXPENSE_FUNDING_LINES: `${BASE_URL}${API_URL}/expenses/funding-lines`,
  EXPENSE_FUNDING_LINE: (lineId) => `${BASE_URL}${API_URL}/expenses/funding-lines/${lineId}`,
  EXPENSE_TRANSACTIONS: `${BASE_URL}${API_URL}/expenses/transactions`,
  EXPENSE_TRANSACTION: (transactionId) => `${BASE_URL}${API_URL}/expenses/transactions/${transactionId}`,
  EXPENSE_TRANSACTION_VOID: (transactionId) => `${BASE_URL}${API_URL}/expenses/transactions/${transactionId}/void`
};
